'use client';
import React from 'react';

import { useAskModalStore } from '@/store/store';
import Link from 'next/link';

export default function Header() {
  const { openModal } = useAskModalStore();

  const closeMobileSideMenu = () => {
    $('.icon.menu i').trigger('click');
  }

  return (
    <>
      <header>
        <div className="inner_wrap">
          <h1 className="logo">
            <a href="/">
              <img src="/img/logo/logo.svg" alt="아이원페이먼트 로고" />
              <p>아이원페이먼트</p>
            </a>
          </h1>
          <p>
            <img src="/img/venture/venture_width.png" style={{ width: '5.125rem', marginLeft: '0.3125rem' }} />
          </p>
          <a className="icon menu">
            <i />
          </a>
          <div className="gnb_wrap">
            <div className="overlay" />
            <nav>
              <ul className="main_menu">
                <li>
                  <strong className="menu_item has_sub">
                    <Link onClick={closeMobileSideMenu} href={'/about'}>회사소개</Link>
                  </strong>
                  <ul className="sub_menu">
                    {/* <li>
                      <a href="#none">㈜아이원페이먼트</a>
                    </li> */}
                    <li>
                      <Link onClick={closeMobileSideMenu} href={'/about'}>연혁</Link>
                      {/* <a href="#none">연혁</a> */}
                    </li>
                  </ul>
                </li>
                <li>
                  <strong className="menu_item">
                    <Link onClick={closeMobileSideMenu} href={"/#main_factory"} >서비스 소개</Link>
                    {/* <a href="/#main_factory">서비스 소개</a> */}
                  </strong>
                </li>
                {/* <li>
                  <strong className="menu_item has_sub">
                    <a href="#none">제품군</a>
                  </strong>
                  <ul className="sub_menu">
                    <li>
                      <a href="#none">무선 단말기</a>
                    </li>
                    <li>
                      <a href="#none">유선 단말기</a>
                    </li>
                    <li>
                      <a href="#none">포스기</a>
                    </li>
                    <li>
                      <a href="#none">키오스크</a>
                    </li>
                    <li>
                      <a href="#none">테이블 오더기</a>
                    </li>
                  </ul>
                </li> */}
                <li>
                  <strong className="menu_item link">
                    <a
                      href="https://blog.naver.com/i-onepay/223799068250"
                      target="_blank"
                      onClick={closeMobileSideMenu}
                    >
                      설치 사례
                    </a>
                  </strong>
                </li>
                <li>
                  <strong className="menu_item">
                    <a onClick={() => {
                      closeMobileSideMenu();
                      openModal();
                    }}>문의하기</a>
                  </strong>
                </li>
              </ul>
              <div className="util_menu">
                <ul className="lang">
                  <li>
                    <a className="active" href="#none">
                      KOR
                    </a>
                  </li>
                  <li>
                    <a href="#none">ENG</a>
                  </li>
                </ul>
                <div className="contact">
                  <p>032. 209. 1056~9</p>
                  <a href="mailto:i-one@ionepayment.com">i-one@ionepayment.com</a>
                </div>
                <p className="copyright">© IONE PAYMENT. All reserved.</p>
              </div>
            </nav>
          </div>
        </div>
        <div className="loading">
          <div className="logo_splash">
            <img src="/img/logo/logo.svg" alt="아이원페이먼트 로고" />
            <p>
              비즈니스에 필요한 결제의 모든 것<span>아이원페이먼트</span>
            </p>
          </div>
        </div>
      </header>
    </>
  );
}
